import React from "react";
import TextInput from "../inputs/TextInput";

const Email = ({
	register,
	error,
	placeholder = "Enter your email address",
	required = false,
	className = "",
	id,
}) => {
	return (
		<TextInput
			label=""
			placeholder={placeholder}
			required={required}
			error={error}
			// descriptionBelow="Start typing your address and select from the suggestions"
			hideLabel={true}
			{...register(id, {
				required: required ? "Email is required" : false,
				pattern: {
					value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
					message: "Please enter a valid email address",
				},
			})}
			name={id}
		/>
	);
};

export default Email;
